import { PrizeDTO } from '@/dto/prizeDTO';

export class UserPrizeDTO {
    public id: string;
    public collectionDate!: number[];
    public bookingDate: number[];
    public prize: PrizeDTO;
    public redeemed: boolean;

    constructor(id: string, prizeDTO: PrizeDTO, bookingDate: number[]) {
        this.id = id;
        this.prize = prizeDTO;
        this.bookingDate = bookingDate;
        this.redeemed = false;
    }
}
